export const LIVE_WINDOW = 100;

export const LIVE_PULSE_LIMIT = 10;

export const LIVE_SLOW_MS = 600;

export const LIVE_P95_MIN = 12;

export const LIVE_EVENTS = {
    JOIN: 'traffic:live:join',
    LEAVE: 'traffic:live:leave',
    REQUESTS: 'traffic:requests',
    PULSE: 'traffic:pulse',
    STATUS: 'traffic:live:status',
} as const;
